import {
  getGridStringOperators,
  GridFilterInputValueProps,
  GridFilterOperator,
} from '@mui/x-data-grid';

export default function createStringOperators(
  InputComponent: React.JSXElementConstructor<GridFilterInputValueProps>
): GridFilterOperator[] {
  return getGridStringOperators()
    .filter((operator) => operator.value === 'equals' || operator.value === 'doesNotEqual')
    .map((operator) => ({
      ...operator,
      InputComponent,
    }));
}
